import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../types/firebase';
import AdminLayout from '../components/AdminLayout';
import GiftTable from '../components/GiftTable';
import Loading from '../components/Loading';
import { GuestGroup } from '../types/interfaces';
import {
  FALLBACK_ILS_PER_EUR,
  FALLBACK_USD_PER_EUR,
  fallbackEurRates,
  fetchEurRates,
  type EurRates,
} from '../utils/exchangeRate';

const Gifts: React.FC = () => {
  const [guestGroups, setGuestGroups] = useState<GuestGroup[]>([]);
  const [rates, setRates] = useState<EurRates | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const [fetchedRates, querySnapshot] = await Promise.all([
          fetchEurRates(),
          getDocs(collection(db, 'guestGroups')),
        ]);
        if (cancelled) return;
        setRates(fetchedRates);
        setGuestGroups(
          querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          })) as GuestGroup[],
        );
      } catch (error) {
        console.error('Error loading gifts data:', error);
        setRates(fallbackEurRates());
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AdminLayout>
      <section className="bg-white p-6 rounded-lg shadow-md">
        {!rates?.live && rates != null && (
          <p
            className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md py-2 px-3 mt-0 mb-4"
            role="alert"
          >
            Could not load live exchange rates. Using fallback: 1 EUR = {rates.ilsPerEur} ILS, 1 EUR
            = {rates.usdPerEur} USD (defaults {FALLBACK_ILS_PER_EUR} / {FALLBACK_USD_PER_EUR}).
          </p>
        )}
        {loading || rates == null ? (
          <Loading size="sm" />
        ) : (
          <GiftTable guestGroups={guestGroups} rates={rates} />
        )}
      </section>
    </AdminLayout>
  );
};

export default Gifts;
